import "../style.css";
import React from 'react';
import PanelContent from "../components/PanelContent"

export default function Captation() {
  return (
    <PanelContent 
        id="captation_pannel"
        route="/captation"
        title="Captation du courant"
        subtitle="Le capteur de courant rétractable et son rôle essentiel"
        description="Enfin, la dernière étape permet la transmission de l'énergie de la piste ERS aux batteries du véhicule. Le capteur de courant rétractable se déploie lorsque le véhicule est sur la section ERS pour capter l'énergie par conduction électrique, puis se rétracte automatiquement à la fin de la piste ou en cas d'événement interrompant l'alimentation (obstacle, dépassement, etc.)."
        prev="/smartpowering"
        next="/charge"
        txtbtn="ÉTAPE SUIVANTE"
    />
  );
}